/* eslint-disable  @typescript-eslint/no-non-null-assertion */
import { Component, DestroyRef, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { WINDOW } from '@frontend/vanilla/core';
import { NgxPopperjsContentComponent, NgxPopperjsDirective, NgxPopperjsPlacements, NgxPopperjsTriggers } from 'ngx-popperjs';
import { distinctUntilKeyChanged } from 'rxjs';

import { TooltipData, TooltipService } from './tooltip.service';

@Component({
    selector: 'ms-general-tooltip',
    templateUrl: './general-tooltip.component.html',
    imports: [NgxPopperjsDirective, NgxPopperjsContentComponent],
})
export class GeneralTooltipComponent implements OnInit {
    tooltipPlacement: NgxPopperjsPlacements;
    hideOnScroll: boolean;
    private destroyRef = inject(DestroyRef);
    private readonly _window = inject(WINDOW);

    @ViewChild('tooltipMessage', { static: true }) tooltipMessage: ElementRef<HTMLSpanElement>;
    @ViewChild(NgxPopperjsDirective, { static: true }) tooltipController: NgxPopperjsDirective | undefined;

    constructor(private tooltip: TooltipService) {}

    NgxPopperjsTriggers = NgxPopperjsTriggers;
    private visible = false;

    ngOnInit(): void {
        this.tooltip.visibility.pipe(distinctUntilKeyChanged('visible'), takeUntilDestroyed(this.destroyRef)).subscribe((request) => {
            if (!this.tooltipController) {
                return;
            }

            if (request.visible && request.data && request.data.content && request.data.reference) {
                this.tooltipController.targetElement = request.data.reference.nativeElement as HTMLElement;
                this.tooltipController.applyClass = request.data.cssClass;
                this.setContent(request.data);
                this.tooltipPlacement = request.data.tooltipPlacement as NgxPopperjsPlacements;
                this.hideOnScroll = request.data.hideOnScroll;
                this.visible = true;

                this._window.setTimeout(() => this.visible && this.tooltipController!.show());
            } else if (this.visible) {
                this.visible = false;
                this.tooltipController.hide();
            }
        });
    }

    private setContent(data: TooltipData): void {
        if (data.appendContent) {
            this.tooltipMessage.nativeElement.innerHTML = '';
            data.content.map((c) => this.tooltipMessage.nativeElement.appendChild(c.nativeElement) as HTMLElement);
        } else {
            this.tooltipMessage.nativeElement.innerHTML = data.content
                .map((c) => {
                    const nativeElement = c.nativeElement as HTMLElement;
                    return nativeElement.innerHTML;
                })
                .join('<br/>');
        }
    }
}
